import React from 'react';
import Image from 'next/image';
import { slugify } from '@/lib/slugify';

interface ContentSectionProps {
  title: string;
  description: string[];
  image?: string;
  imageAlt?: string;
  reverse?: boolean; // Optional: to allow image on left or right
  id?: string;
}

const ContentSection: React.FC<ContentSectionProps> = ({ title, description, image, imageAlt = '', reverse = false, id }) => {
  const sectionId = id || slugify(title);

  return (
    <section id={sectionId} className="py-10 md:py-16 bg-white">
      <div className={`container mx-auto px-4 flex flex-col ${reverse ? 'md:flex-row-reverse' : 'md:flex-row'} items-center gap-8 md:gap-16`}>
        <div className="w-full md:w-1/2 animate-fadeIn">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-primary-dark mb-4">
            <a href={`#${sectionId}`} className="group inline-flex items-start gap-2 hover:text-primary-dark">
              {title}
              <span className="text-primary-dark opacity-0 transition-opacity duration-200 group-hover:opacity-100">#</span>
            </a>
          </h2>
          {description.map((para, idx) => (
            <p key={idx} className="text-gray-700 text-lg leading-relaxed mb-4 last:mb-0">{para}</p>
          ))}
        </div>
        <div className="w-full md:w-1/2 flex justify-center items-center animate-fadeIn" style={{animationDelay: '0.2s'}}>
          {image ? (
            <div className="rounded-2xl overflow-hidden shadow-lg border border-primary-light bg-white">
              <Image src={image} alt={imageAlt || title} width={480} height={320} className="object-cover w-full h-auto" />
            </div>
          ) : (
            <div className="w-48 h-32 md:w-80 md:h-48 flex items-center justify-center">
              {/* Decorative SVG shape splitter */}
              <svg viewBox="0 0 320 120" width="100%" height="100%" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0,60 Q80,0 160,60 T320,60 Q240,120 160,60 T0,60" fill="#FE7F2D" opacity="0.15" />
                <path d="M0,80 Q80,40 160,80 T320,80" stroke="#215E61" strokeWidth="4" fill="none" opacity="0.3" />
              </svg>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default ContentSection;
